// src/pages/ServiciosPage.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import ChromaGrid from '../components/ChromaGrid/ChromaGrid';
import { servicesData } from '../data/servicesData';
import Button from '../components/Button/Button';
import DarkVeil from '../components/DarkVeil/DarkVeil';
import '../App.css'; // Reutilizamos algunos estilos

const ServiciosPage: React.FC = () => {
  return (
    <div className="section">
      <h1 className="section-title">Nuestros Servicios</h1>
      <div style={{ height: '800px', position: 'relative', marginBottom: '40px' }}>
        <ChromaGrid 
          items={servicesData}
          radius={350}
          damping={0.3}
        />
      </div>
    </div>
  );
};

export default ServiciosPage;